export default __webpack_public_path__ + "text-editor-section.png";